import { Component, OnInit } from '@angular/core';
import { PostService } from "../../Services/post.service"
import { InventoryService } from "../../Services/inventory.service"

import {bookInventory} from '../../shared/interfaces/bookInventory.interface';
@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.css']
})
export class BooksComponent implements OnInit {

  calculatedBookInventory: bookInventory[] = [];
  donatedBookInventory: bookInventory[] = [];

  constructor(private postService: PostService, private inventoryService: InventoryService) {

    this.inventoryService.getRequiredBooks().subscribe(books => {
   //   console.log(books);
      this.calculatedBookInventory = books;
    });

    // this.inventoryService.getDonnatedBooks().subscribe(books => {
    // //  console.log(books);
    //   this.donatedBookInventory = books;
    // });

  }

  ngOnInit() {
  }

  // save() {
  //   this.postService.postBooks(this.donatedBookInventory);
  // }
  // cancel() {
  //   this.inventoryService.getDonnatedBooks().subscribe(books => {
  //     this.donatedBookInventory = books;
  //   });
  // }
}


// WEBPACK FOOTER //
// ./src/app/Components/books/books.component.ts